import PropTypes from 'prop-types';
import classNames from 'clsx';
import playerStatuses from 'src/common/utils/playerStatuses';
import playerStatusToIconMap, {
  playerIconClasses,
} from 'src/common/utils/playerStatusToIconMap';

import CircularProgress from '../../shared/CircularProgress';
import PlayCircleSolid from '../../shared/svgIcons/player/PlayCircleSolid';
import PauseCircleSolid from '../../shared/svgIcons/player/PauseCircleSolid';
import StopCircleSolid from '../../shared/svgIcons/player/StopCircleSolid';

import css from './play-button.module.scss';

const svgProps = {
  height: '28.5%',
  width: '28.5%',
  viewBox: '0 0 45 45',
  fill: '#FFFFFF',
  className: css.iconPosition,
  doNotHover: true,
  preserveAspectRatio: 'xMaxYMax',
};

const tileSizeSvgPropsMap = {
  Regular: {
    height: '60%',
    width: '60%',
    className: classNames(css.iconPosition, css.regularTileSizeOffset),
  },
};

const tileShapeSvgPropsMap = {
  Circle: {
    height: '40%',
    width: '40%',
    className: classNames(css.iconPosition, css.circleTileShapeOffset),
  },
};

const svgIconClassMap = {
  [playerIconClasses.play]: {
    SvgComponent: PlayCircleSolid,
    dataTestId: 'playIcon',
  },
  [playerIconClasses.pause]: {
    SvgComponent: PauseCircleSolid,
    dataTestId: 'pauseIcon',
  },
  [playerIconClasses.stop]: {
    SvgComponent: StopCircleSolid,
    dataTestId: 'stopIcon',
  },
};

const PlayTile = ({
  syncedPlayerStatus,
  canScrub,
  isMobile,
  tileSize,
  tileShape,
}) => {
  const iconClassName = playerStatusToIconMap[syncedPlayerStatus](canScrub);
  const isPlayingOrConnecting =
    syncedPlayerStatus === playerStatuses.playing ||
    syncedPlayerStatus === playerStatuses.connecting;

  const { SvgComponent, dataTestId } = svgIconClassMap[iconClassName] || {};
  const tileSizePropsOverride = tileSizeSvgPropsMap[tileSize] || {};
  const tileShapePropsOverride = tileShapeSvgPropsMap[tileShape] || {};
  const svgComponentProps = {
    ...svgProps,
    ...tileSizePropsOverride,
    ...tileShapePropsOverride,
    dataTestId,
  };

  return (
    <div
      data-testid="guideItemPlayOverlay"
      className={classNames(css.overlay, {
        [css.show]: isPlayingOrConnecting,
        [css.hide]: !isPlayingOrConnecting,
        [css.mobile]: isMobile,
      })}
    >
      {syncedPlayerStatus === playerStatuses.connecting && (
        <div className={css.progressWrapper}>
          <CircularProgress color="#fff" thickness={2} size={40} />
        </div>
      )}
      {SvgComponent && <SvgComponent {...svgComponentProps} />}
    </div>
  );
};

PlayTile.propTypes = {
  syncedPlayerStatus: PropTypes.string,
  canScrub: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  tileSize: PropTypes.string,
  tileShape: PropTypes.string,
};

export default PlayTile;
